import { BasePresenter } from "../base/base.presenter";
import { IResumeProa } from "../../interfaces/screens/resume-proa.interface";
import { useSelector } from "react-redux";
import { Utilities, moment, String, Constants, Enums } from "@utils";
import { ILang, IBudgetFormBasicDataMasters } from "@models/*";
import { dxDataGridColumn } from "devextreme/ui/data_grid";
import { IDataGridOptions } from "devextreme-react/data-grid";
import {
  IProaService,
  ProaService,
} from "@services/proyecta/proa-form.service";

export class ResumeProaPresenter extends BasePresenter<IResumeProa> {
  private currentLang: ILang;
  private service: IProaService;
  public params: any;
  public formMasters: IBudgetFormBasicDataMasters;

  constructor(view: IResumeProa) {
    super(view);
    this.currentLang = useSelector(this.context.sessionStore.selectLang);
    
    this.service = new ProaService();
  }
  public async getAllColumnsDefinitions() {
    this.dispatcherProgress(50);
    if (!Utilities.isNullObject(this.currentLang)) {
      const columns = await this.service.getSummaryFieldsDefinition(
        this.currentLang.id
      );
      this.view.state.setDataColumns(columns);
    }
  }
  public getAllProaSummary() {
    this.dispatcherProgress(0);
    this.dispatcherPendingLoad(1);
    this.dispatcher(this.context.proaStore.getAllFormMasters());
    this.dispatcher(this.context.proaStore.getProaSummary());
  }
  public resetForm() {
    this.dispatcherProgress(100);
    this.dispatcher(this.context.proaStore.actions.setCurrentBudget(null));
    this.dispatcher(
      this.context.proaStore.actions.setCurrentBudgetDetails(null)
    );
    this.dispatcherUnsetSetLoading();
  }
  public get getSummary(): any {
    let summaryData: any[] = useSelector(this.context.proaStore.selectSummaryData);
    let formMasters = useSelector(this.context.proaStore.selectFormMasters);
    let params = useSelector(this.context.sessionStore.selectParams);
    let auxData = Utilities.copyObject(summaryData)
    if(params && Object.keys(params)?.length && formMasters){
      auxData?.forEach((x: any) => {
        x.canEdit = this.getTotalPermissions(x.PPrespais, params, formMasters)
        return x
      })
    }
    return auxData
  }
  public getTotalPermissions(country: string, params: any, formMasters: any){
    const TEAM_CENTRAL = params?.[Enums.Params.proyectaCentralTeam]
    const ADMIN_GROUP = params?.[Enums.Params.proyectaAdminModule]
    let countryRegionGroup: string = [...formMasters?.countries, ...formMasters?.regions]?.find((cr: any) => cr.Title === country)?.SGGrupoAD

    let userGroupsId: any[] = this?.currentUser?.userGroups?.map((x: any) => x.id)
    let userGroupsName: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)
    
    return (userGroupsName?.includes(TEAM_CENTRAL) || userGroupsName?.includes(ADMIN_GROUP) || userGroupsId?.includes(countryRegionGroup))
  }
  public getFields(fieldName: string) {
    if (Utilities.isNullObject(this.view.state.dataColumns))
      return String.Empty;

    return (
      this.view.state.dataColumns.get(fieldName)?.NombreColumna ?? String.Empty
    );
  }
  public getNextYear() {
    const today = new Date();
    const year = today.getFullYear();
    return (year + 1).toString();
  }
  private fields(): dxDataGridColumn[] {
    return [
      {
        caption: this.getFields("AÑO"),
        dataField: "PPresuAnio",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("País"),
        dataField: "PPrespais",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Linea Intervención"),
        dataField: "PPresLineaInter",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Proyecto"),
        dataField: "PProaCodProyecto",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Titulo"),
        dataField: "Title",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Financiador"),
        dataField: "PProaFinanciador",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Subvención"),
        dataField: "PProaCodSubv",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Total"),
        dataField: "PPresTotalAnio1",
        visible: true,
        dataType: "number",
        format: "€ #,##0",
      },
      {
        caption: this.getFields("Estado"),
        dataField: "PProaEstado",
        visible: true,
        dataType: "string",
      },
      {
        caption: this.getFields("Acciones"),
        dataField: "botones",
        alignment: "center",
        type: "buttons",
        buttons: [
          {
            hint: "Ver",
            icon: "bulletlist",
            visible: true,
            onClick: (e) => {
              this.context.history.push(
                `/proyecta/proa/view?Id=${e.row.data.PPresPresupuestoId}`
              );
            },
          },
          {
            hint: "Editar",
            icon: "edit",
            visible: (e) => e.row.data?.canEdit,
            onClick: (e) => this.onClickEdit(e, this.currentLang.label),
          },
        ],
      },
    ];
  }
  public onClickEdit(e: any, currentLang: string) {
    let _value = Constants.ProaPlanState.ApprovedEs;
    switch (currentLang) {
      case "EN":
        _value = Constants.ProaPlanState.ApprovedEn;
        break;
      case "PT":
        _value = Constants.ProaPlanState.ApprovedPt;
        break;
      case "FR":
        _value = Constants.ProaPlanState.ApprovedFr;
        break;
    }
    if (e.row.data.PProaEstado === _value) {
      this.context.history.push(
        `/proyecta/proa/view?Id=${e.row.data.PPresPresupuestoId}`
      );
    } else {
      this.context.history.push(
        `/proyecta/proa/edit?Id=${e.row.data.PPresPresupuestoId}`
      );
    }
  }
  public options: IDataGridOptions = {
    columns: this.fields(),
    dataSource: this.getSummary,
    summary: {
      totalItems: [
        {
          column: this.getFields("Total"),
          summaryType: "sum",
          valueFormat: " € #,##0",
        },
      ],
    },
    filterPanel: { visible: true },
    filterRow: { visible: true },
    columnMinWidth: 100,
    export: {
      fileName: "Proa Summary",
      enabled: true,
      excelFilterEnabled: true,
    },
    defaultFilterValue: ["PPresuAnio", "contains", this.getNextYear()],
    stateStoring: {
      enabled: true,
      type: "localStorage",
      storageKey: "storage_proa_summary" 
  }  
  };
  public get lastUpdateDate(): any {
    let result = String.Empty;
    const data: any[] = useSelector(this.context.proaStore.selectSummaryData);
    const tagsTraduction: any = useSelector(
      this.context.sessionStore.selectLabels
    );

    if (
      !Utilities.isNullEmptyObject(data) &&
      !Utilities.isNullObject(tagsTraduction)
    ) {
      if (!Utilities.isEmptyObject(data)) {
        result = moment.utc(data[data.length - 1].Created).tz(Constants.GeneralFormats.TIME_ZONE).format(
          "MMMM Do YYYY, h:mm a"
        );
      } else {
        result = moment(new Date()).format("MMMM Do YYYY, ") + "1:00 am";
      }
      result = String.Format(
        "{0}: {1}",
        tagsTraduction.get("Última Actualización"),
        result
      );
    }

    return result;
  }
}
